import { useEffect } from 'react';

export const useScrollToElement = (querySelector, options = {}) => {
  const { enabled = true, dependencies, callback } = options;

  const scrollToElement = (selector) => {
    try {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } catch (error) {
      console.error('Error in scrollToElement:', error);
    }
  };

  useEffect(() => {
    if (!enabled) return;

    scrollToElement(querySelector);
    if (callback) callback();
  }, [querySelector, enabled, dependencies]);

  return scrollToElement;
};
